export default __webpack_public_path__ + "static/media/m_section5-pic1.c17f3060.png";